<template>
    <div class="text text--help">
        Если у вас есть вопросы, идеи или проблемы, мы всегда рады помочь! Напишите нам на почту: support@flirtby.blog. Наша команда поддержки ответит вам в кратчайшие сроки. Мы стремимся сделать ваш опыт общения на нашем сайте максимально комфортным и приятным!
        <b>support@flirtby.blog</b>
    </div>
</template>

<style lang="scss">
.text--help {
    width: 100%;
    max-width: 460px;
    margin: 0 auto;
}
</style>